import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { LocationOnOutlined, PhoneOutlined, CheckCircleOutline } from '@mui/icons-material';
import axios from 'axios';
import '../styles/common.css';
import '../styles/SeoPages.css';
import goldHeroObj from '../images/gold-jewellery-hero.png';

const GoldJewelleryPage = () => {
    const [goldCount, setGoldCount] = useState(null);

    useEffect(() => {
        axios.get('/api/jewellery?type=Gold&limit=1&page=1')
            .then(res => { if (res.data.total) setGoldCount(res.data.total); })
            .catch(() => {});
    }, []);

    return (
        <div className="page-container seo-page">
            <Helmet>
                <title>Gold Jewellery in Jodhpur | BIS Hallmark Gold – MAB Jewels</title>
                <meta name="description" content="Buy BIS hallmark certified gold jewellery in Jodhpur at MAB Jewels. Explore 22K & 18K gold rings, bangles & necklaces with transparent pricing." />
            </Helmet>
            <div className="seo-content-wrapper">
                <h1>Gold Jewellery in Jodhpur – BIS Hallmark Gold at MAB Jewels</h1>

                {/* Hero Image */}
                <div className="seo-hero-image-container">
                    <img
                        src={goldHeroObj}
                        alt="Gold jewellery in Jodhpur – BIS hallmark gold at MAB Jewels"
                        className="seo-hero-image"
                        style={{ width: '100%', borderRadius: '12px', marginBottom: '30px', boxShadow: '0 8px 20px rgba(0,0,0,0.1)' }}
                    />
                </div>

                <p className="seo-intro">
                    Looking for trusted <strong>gold jewellery in Jodhpur</strong>?
                    MAB Jewels offers BIS hallmark certified 22K & 18K gold jewellery, handcrafted with purity, tradition, and transparent pricing. Trusted by families across Rajasthan for generations.
                    {goldCount && <strong> Explore our collection of {goldCount}+ certified gold pieces.</strong>}
                </p>

                <div style={{ marginBottom: '20px' }}>
                    <Link to="/jewellery" style={{ display: 'inline-block', background: 'linear-gradient(135deg, #d4af37, #b8960c)', color: '#fff', padding: '12px 24px', borderRadius: '8px', fontWeight: '700', textDecoration: 'none' }}>
                        Browse Our Gold Collection →
                    </Link>
                </div>

                <h2>Why Choose MAB Jewels for Gold Jewellery in Jodhpur</h2>
                <ul className="seo-check-list">
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> BIS Hallmark Certified Gold Jewellery</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> 22K & 18K purity options</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Transparent pricing based on live gold rates</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Traditional & modern designs</li>
                    <li><CheckCircleOutline sx={{ color: '#d4af37', mr: 1, fontSize: '1.2rem' }} /> Trusted local jeweller in Jodhpur, Rajasthan</li>
                </ul>

                <h2>Our Gold Jewellery Collection</h2>
                <p>
                    Explore an exclusive range of gold jewellery in Jodhpur, perfect for daily wear, gifting, and weddings:
                </p>
                <ul>
                    <li>Gold rings for men & women</li>
                    <li>Gold necklaces & chains</li>
                    <li>Bangles, kadas & bracelets</li>
                    <li>Earrings & traditional designs</li>
                    <li>Custom gold jewellery on request</li>
                </ul>
                <p>Each piece reflects skilled craftsmanship and timeless Indian tradition.</p>

                <h2>Trusted Gold Jeweller in Jodhpur</h2>
                <p>
                    Located in Rajasthan, MAB Jewels is known for honest dealings, purity assurance, and customer trust.
                    Whether you're buying gold for investment, weddings, or family occasions, we ensure value and transparency.
                </p>

                <h2>Visit Our Gold Jewellery Store in Jodhpur</h2>
                <p>
                    Visit our showroom or <strong>contact us</strong> today to explore the finest gold jewellery in Jodhpur with live gold rates and expert guidance.
                </p>

                {/* Local SEO Boost */}
                <div className="local-seo-box">
                    <h3>Contact MAB Jewels</h3>
                    <div className="seo-contact-row">
                        <LocationOnOutlined sx={{ color: '#d4af37', mr: 1 }} />
                        <span>Rajasthan, India</span>
                    </div>
                    <div className="seo-contact-row">
                        <PhoneOutlined sx={{ color: '#d4af37', mr: 1 }} />
                        <span>+91 94148 17620</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoldJewelleryPage;
